import React from 'react'
import { Route } from 'react-router'

const PublicRoute = ({ props: passedProps, path, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      path={path}
      render={(routerProps) => {
        return(
          <Component {...routerProps} {...passedProps} />
        )
      }}
    />
  )
}

export default PublicRoute